import { useWebsiteSettings } from 'publisher/store'
import React from 'react'
import { getWebsiteStylesTypographyParagraph } from 'src/publisher/store/website-settings/website-settings-selector'
import Meta from '../components/core/Meta'
import { OnExitPopup } from './components/on-exit-popup'
import { OnloadPopups } from './components/onload-popups'
import { TriggeredPopup } from './components/triggered-popup'
import PageUi from './ui/PageUi'

export interface WebsitePageProps {
  noIndex?: boolean
  children: React.ReactNode
}

export const WebsitePage = ({
  children,
  noIndex = false,
}: WebsitePageProps) => {
  const { fontFamily, fontWeight, fontStyle } =
    useWebsiteSettings(getWebsiteStylesTypographyParagraph) || {}
  return (
    <PageUi
      $textFontFamily={fontFamily}
      $textFontWeight={fontWeight}
      $textFontStyle={fontStyle}
    >
      <Meta noIndex={noIndex} />
      {children}
      <TriggeredPopup />
      <OnExitPopup />
      <OnloadPopups />
    </PageUi>
  )
}
